<template>
  <div class="step-three tutorial">
    <h2>Hosting on Azure</h2>
    <h4>Creating an static app</h4>
    <h4>Linkning your Repository</h4>
    <h4>Azure Subscription</h4>
  </div>
</template>
